export const DriveService = {
    // Crear una carpeta en Google Drive (opcionalmente dentro de otra)
    async createFolder(folderName, accessToken, parentId = null) {
        try {
            const body = {
                name: folderName,
                mimeType: 'application/vnd.google-apps.folder'
            };
            if (parentId) {
                body.parents = [parentId];
            }

            const response = await fetch('https://www.googleapis.com/drive/v3/files', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error?.message || 'Error creando carpeta');
            return data.id;
        } catch (error) {
            console.error("Drive Folder Creation Error:", error);
            throw error;
        }
    },

    // Subir archivo a una carpeta específica con nombre estandarizado
    async uploadFile(file, accessToken, folderId = null, customName = null) {
        try {
            const boundary = '-------314159265358979323846';
            const delimiter = "\r\n--" + boundary + "\r\n";
            const close_delim = "\r\n--" + boundary + "--";

            const fileName = customName || file.name;
            const contentType = file.type || 'application/octet-stream';

            const metadata = {
                name: fileName,
                mimeType: contentType
            };
            if (folderId) {
                metadata.parents = [folderId];
            }

            // Construir el cuerpo multipart con Blob para mezclar JSON y binario
            const header = `--${boundary}\r\nContent-Type: application/json\r\n\r\n${JSON.stringify(metadata)}\r\n`;
            const separator = `\r\n--${boundary}\r\nContent-Type: ${contentType}\r\n\r\n`;
            const footer = `\r\n--${boundary}--`;

            const bodyBlob = new Blob([header, separator, file, footer], { type: `multipart/related; boundary=${boundary}` });

            const response = await fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': `multipart/related; boundary=${boundary}`
                },
                body: bodyBlob
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.error?.message || 'Error en Drive upload');
            return data;
        } catch (error) {
            console.error("Drive Upload Error:", error);
            throw error;
        }
    },

    // Obtener link de visualización o descarga
    getFileLink(fileId) {
        return `https://drive.google.com/file/d/${fileId}/view`;
    }
};
